import { useParams } from "react-router";
import { CompanyProfileCard } from "@/services/backend/company/components/company-profile-card";

export function CompanyProfileRoute() {
  const { companyId } = useParams();

  return (
    <div className="grid gap-2">
      <CompanyProfileCard companyId={companyId!} />
    </div>
  );
}
